import React from "react";
import { Row, Col } from "reactstrap";
import ShareButton from "./ShareButton";

export default class DetailShareTools extends React.Component {

    goToFacebook() {
        window.open("https://www.facebook.com/yuantathai");
    }

    goToYouTube() {
        window.open("https://www.youtube.com/@yuantathai");
    }

    copyToClipboard(text) {      
        const textarea = document.createElement('textarea');
        textarea.value = text;
        document.body.appendChild(textarea);
        textarea.select();
        document.execCommand('copy');
        document.body.removeChild(textarea);
    }

    handlePhoneNumber() {
        const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
        const phoneNumber = "0 2009 8888";
        if (isMobile) {
            // If it's a mobile device, initiate a phone call
            window.location.href = `tel:${phoneNumber}`;
        } else {
            // If it's not a mobile device, copy to clipboard
            this.copyToClipboard(phoneNumber);
            alert('Phone number copied to clipboard!');
        }
    }
    render() {
        return <Row>
            <Col className="left-tools">
                <span>{this.props.updatedAt}</span>
                {/* <button className="icon" onClick={() => this.goToFacebook()}>
                    <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M35.8466 17.9545C35.8465 14.5522 34.8689 11.2212 33.0295 8.35595C31.1901 5.49071 28.566 3.21129 25.468 1.78762C22.37 0.363959 18.9278 -0.144303 15.5491 0.323032C12.1705 0.790367 8.99683 2.21372 6.4041 4.42452C3.81136 6.63533 1.90814 9.54097 0.91982 12.7973C-0.0684968 16.0537 -0.100503 19.5244 0.827593 22.7983C1.75569 26.0723 3.605 29.0123 6.15653 31.2703C8.70805 33.5283 11.8549 35.0097 15.2244 35.5389V23.0969H10.6796V17.9545H15.2244V14.0331C15.2244 9.57107 17.8683 7.10799 21.953 7.10799C23.2914 7.12667 24.6266 7.24301 25.9479 7.45609V11.8364H23.698C21.4798 11.8364 20.7897 13.2077 20.7897 14.6159V17.9545H25.7391L24.9459 23.0969H20.7897V35.5363C24.9869 34.8733 28.8092 32.7383 31.5693 29.5154C34.3293 26.2926 35.846 22.1932 35.8466 17.9545Z" fill="#0246A6" />
                    </svg>
                </button>
                <button className="icon" onClick={() => this.goToYouTube()}>
                    <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <circle cx="20" cy="20" r="20" fill="#EBEBEB" />
                        <path d="M29.5543 29.2007H11.1529C8.69073 29.2007 6.70703 27.0232 6.70703 24.3449V15.6566C6.70703 12.9674 8.7007 10.8008 11.1529 10.8008H29.5543C32.0165 10.8008 34.0002 12.9783 34.0002 15.6566V24.3449C34.0102 27.0341 32.0165 29.2007 29.5543 29.2007Z" fill="#0246A6" />
                        <path d="M25.1805 19.8643L17.4395 15.4004V24.3282L25.1805 19.8643Z" fill="white" />
                    </svg>
                </button>
                <button onClick={() => this.handlePhoneNumber() }>
                    <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <circle cx="20" cy="20" r="20" fill="#EBEBEB" />
                        <path d="M28.6125 29.75C26.2833 29.75 24.013 29.2307 21.8016 28.1922C19.5894 27.1543 17.6304 25.7821 15.9245 24.0755C14.2179 22.3696 12.8457 20.4106 11.8078 18.1984C10.7693 15.987 10.25 13.7167 10.25 11.3875C10.25 11.0625 10.3583 10.7917 10.575 10.575C10.7917 10.3583 11.0625 10.25 11.3875 10.25H15.775C16.0278 10.25 16.2535 10.3312 16.4521 10.4937C16.6507 10.6562 16.7681 10.8639 16.8042 11.1167L17.5083 14.9083C17.5444 15.1611 17.5401 15.3911 17.4953 15.5984C17.4498 15.8064 17.3458 15.9917 17.1833 16.1542L14.5833 18.8083C15.3417 20.1083 16.2896 21.3271 17.4271 22.4646C18.5646 23.6021 19.8194 24.5861 21.1917 25.4167L23.7375 22.8708C23.9 22.7083 24.1123 22.5863 24.3745 22.5047C24.6359 22.4238 24.8931 22.4014 25.1458 22.4375L28.8833 23.1958C29.1361 23.25 29.3438 23.3717 29.5063 23.5609C29.6688 23.7509 29.75 23.9722 29.75 24.225V28.6125C29.75 28.9375 29.6417 29.2083 29.425 29.425C29.2083 29.6417 28.9375 29.75 28.6125 29.75Z" fill="#0246A6" />
                    </svg>
                </button> */}
            </Col>
            <Col className="align-right">
                <ShareButton contentType={this.props.contentType} />
            </Col>
        </Row>
    }
}